import React from "react";
import _ from "underscore";

import NavBar from "../../components/nav-bar";
import SideBar from "../../components/sidebar";


function FarmDivision() {

    const worldElectricityProduction = [
        {
            year: 1985,
            division1: 1488.9216,
            division2: 1110.7847,
            division3: 1426.3086,
            division4: 3748.3848,
        },
        {
            year: 1986,
            division1: 1594.7357,
            division2: 1168.3097,
            division3: 1432.6683,
            division4: 3839.0095,
        },
        {
            year: 1987,
            division1: 1734.7332,
            division2: 1183.1947,
            division3: 1516.4941,
            division4: 4058.0767,
        },
        {
            year: 1988,
            division1: 1891.2493,
            division2: 1256.5684,
            division3: 1540.9414,
            division4: 4200.6743,
        },
        {
            year: 1989,
            division1: 1945.0106,
            division2: 1350.2358,
            division3: 1728.5189,
            division4: 4376.982,
        },
        {
            year: 1990,
            division1: 2000.596,
            division2: 1364.6844,
            division3: 1789.7031,
            division4: 4460.2417,
        },
        {
            year: 1991,
            division1: 2096.3098,
            division2: 1349.9071,
            division3: 1815.2444,
            division4: 4557.0664,
        },
        {
            year: 1992,
            division1: 2112.223,
            division2: 1328.2163,
            division3: 1829.3868,
            division4: 4649.9165,
        },
        {
            year: 1993,
            division1: 2184.9646,
            division2: 1266.6155,
            division3: 1863.8153,
            division4: 4727.899,
        },
        {
            year: 1994,
            division1: 2225.9788,
            division2: 1302.1187,
            division3: 1925.1002,
            division4: 4891.904,
        },
        {
            year: 1995,
            division1: 2322.5298,
            division2: 1259.9452,
            division3: 2036.3821,
            division4: 5038.9316,
        },
        {
            year: 1996,
            division1: 2406.615,
            division2: 1245.6957,
            division3: 2101.594,
            division4: 5279.661,
        },
        {
            year: 1997,
            division1: 2390.0642,
            division2: 1244.647,
            division3: 2271.0615,
            division4: 5395.626,
        },
        {
            year: 1998,
            division1: 2431.1948,
            division2: 1294.6146,
            division3: 2408.5476,
            division4: 5511.2935,
        },
        {
            year: 1999,
            division1: 2523.7056,
            division2: 1266.6599,
            division3: 2600.75,
            division4: 5630.859,
        },
        {
            year: 2000,
            division1: 2507.43,
            division2: 1209.51,
            division3: 2681.11,
            division4: 5719.12,
        },
        {
            year: 2001,
            division1: 2573.71,
            division2: 1197.6,
            division3: 2827.65,
            division4: 5801.14,
        },
        {
            year: 2002,
            division1: 2601.89,
            division2: 1175.58,
            division3: 3033.78,
            division4: 6056.12,
        },
        {
            year: 2003,
            division1: 2577.71,
            division2: 1198.2,
            division3: 3165.78,
            division4: 6458.61,
        },
        {
            year: 2004,
            division1: 2682.73,
            division2: 1177.47,
            division3: 3408.19,
            division4: 6697.61,
        },
        {
            year: 2005,
            division1: 2686.95,
            division2: 1186.13,
            division3: 3579.99,
            division4: 7040.85,
        },
        {
            year: 2006,
            division1: 2721.42,
            division2: 1097.06,
            division3: 3792.38,
            division4: 7439.88,
        },
        {
            year: 2007,
            division1: 2666.92,
            division2: 1119.39,
            division3: 4109.47,
            division4: 7931.82,
        },
        {
            year: 2008,
            division1: 2656.04,
            division2: 1078.99,
            division3: 4210.51,
            division4: 7927.59,
        },
        {
            year: 2009,
            division1: 2619,
            division2: 1005.12,
            division3: 4247.72,
            division4: 7817.32,
        },
        {
            year: 2010,
            division1: 2686.44,
            division2: 1011.78,
            division3: 4701.27,
            division4: 8358.6,
        },
        {
            year: 2011,
            division1: 2575.35,
            division2: 1103.87,
            division3: 4767.24,
            division4: 8814.17,
        },
        {
            year: 2012,
            division1: 2403.21,
            division2: 1157.13,
            division3: 5042.66,
            division4: 8855.83,
        },
        {
            year: 2013,
            division1: 2418.44,
            division2: 1118.61,
            division3: 4939.52,
            division4: 9306.75,
        },
        {
            year: 2014,
            division1: 2472.7,
            division2: 1063.74,
            division3: 5096.07,
            division4: 9495.57,
        },
        {
            year: 2015,
            division1: 2502.45,
            division2: 1068.09,
            division3: 5418.55,
            division4: 9160.63,
        },
        {
            year: 2016,
            division1: 2540.48,
            division2: 1004.96,
            division3: 5669.08,
            division4: 9226.85,
        },
        {
            year: 2017,
            division1: 2566.22,
            division2: 913.07,
            division3: 5791.83,
            division4: 9518.91,
        },
        {
            year: 2018,
            division1: 2619.57,
            division2: 841.34,
            division3: 6015.24,
            division4: 9899.44,
        },
        {
            year: 2019,
            division1: 2724.08,
            division2: 776.78,
            division3: 6176.34,
            division4: 9680.92,
        },
        {
            year: 2020,
            division1: 2634.69,
            division2: 741,
            division3: 6132.47,
            division4: 9292.9,
        },
        {
            year: 2021,
            division1: 2740.78,
            division2: 793.53,
            division3: 6326,
            division4: 10081.8,
        },
        {
            year: 2022,
            division1: 2610.04,
            division2: 884.98,
            division3: 6309.46,
            division4: 10190.71,
        },
    ];

    return (
        <div className="container-fluid px-0 mb-5">
            <main id="main-layout" role="main" className="pb-3">
                <div className="enquiry-page-wrapper">
                    <NavBar title={"Tonnage by Division"} />
                    <div className="container-fluid">
                        <div className="row">
                            <SideBar />

                            <div className="home-section">
                                <div className="col-lg-12 mb-2 pb-2" id="logContainer">
                                    <div className="row m-0 justify-content-between align-items-center">
                                        <div className="card-header p-0" style={{ borderBottom: "none" }}>
                                            {/* <ul className="nav nav-tabs justify-content-start common-view-tabs" role="tablist">
                                                <li className="nav-item common-view-item">
                                                    <a className="nav-link active common-view-link" data-status-id="0"
                                                        id="nav-Current-tab" data-toggle="tab" href="#nav-Current"
                                                        role="tab" aria-controls="nav-Current"
                                                        aria-selected="true">Scheduler</a>
                                                </li>
                                                <li className="nav-item common-view-item">
                                                    <a className="nav-link common-view-link" data-status-id="1"
                                                        id="nav-History-tab" data-toggle="tab" href="#nav-History"
                                                        role="tab" aria-controls="nav-History"
                                                        aria-selected="true">History</a>
                                                </li>
                                            </ul> */}
                                        </div>
                                        <div className="col-md-6 top-right d-flex justify-content-end align-items-end"
                                            style={{ gap: "10px" }}>
                                            {/* <div className="container-fluid">
                                                <input className="Enquiry-form-control" type="search" id="searchInput"
                                                    placeholder="Search by Process" />
                                            </div> */}
                                            {/* <div className="d-flex" style={{ gap: "10px" }}>
                                                <div>
                                                    <a role="button" className="c-black" href="/temp/Production Schedule.xlsx"
                                                        title="Download Report">
                                                        <i className="f-24 i-btn cursor-pointer ti ti-download"></i>
                                                    </a>
                                                </div>
                                                <a role="button" href="#" className="c-black" data-toggle="tooltip"
                                                    title="Filter" onClick="openSideFilterPanel()">
                                                    <i id="filter-icon" className="f-24 i-btn cursor-pointer ti ti-filter"></i>
                                                </a>
                                            </div> */}
                                            {/* <div id="plan-insert-record">
                                                <i className="f-24 i-btn cursor-pointer ti ti-table-plus" onClick={handleAddOpen}></i>
                                            </div>
                                            <div id="plan-upload-record">
                                                <i className="f-24 i-btn cursor-pointer ti ti-upload"></i>
                                            </div> */}
                                        </div>
                                    </div>
                                    <div className="tab-content mt-1" id="nav-tabContent">
                                        <div className="tab-pane fade show active" id="nav-Current" role="tabpanel"
                                            aria-labelledby="nav-Current-tab">
                                            <div id="list_content" className="table-responsive">
                                                <table className="table-list table-hover schedule-table" style={{ width: "100%" }}
                                                    id="plan-schedule-table">
                                                    <thead>
                                                        <tr className="table-list-header-row" style={{ color: "#ffffff" }}>
                                                            <th>Date</th>
                                                            <th>Division 1</th>
                                                            <th>Division 2</th>
                                                            <th>Division 3</th>
                                                            <th>Division 4</th>
                                                        </tr>
                                                    </thead>

                                                    <tbody className="table-list-body">
                                                        {worldElectricityProduction.map((dt, i) =>
                                                            <tr className="table-list-body-row collapse plan-schedule-row show"
                                                                id={`row-` + i} key={i} data-id="1">
                                                                <td data-type="text" name="year">
                                                                    {dt.year}
                                                                </td>
                                                                <td data-type="text" name="division1">{dt.division1}</td>
                                                                <td data-type="text" name="division2">{dt.division2}</td>
                                                                <td data-type="text" name="division3">{dt.division3}</td>
                                                                <td data-type="text" name="division4">{dt.division4}</td>
                                                            </tr>)}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
        </div>
    );
}
export default FarmDivision;